import { render, staticRenderFns } from "./PhilosophyItem.vue?vue&type=template&id=38c750be&scoped=true&"
import script from "./PhilosophyItem.vue?vue&type=script&lang=js&"
export * from "./PhilosophyItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c750be",
  null
  
)

export default component.exports